const MsftLogo = (props) => {
  return (
    <svg
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0.5 0H12.5V12H0.5V0Z" fill="#F25022" />
      <path d="M13.8333 0H25.8333V12H13.8333V0Z" fill="#7FBA00" />
      <path d="M0.5 13.3333H12.5V25.3333H0.5V13.3333Z" fill="#00A4EF" />
      <path
        d="M13.8333 13.3333H25.8333V25.3333H13.8333V13.3333Z"
        fill="#FFB900"
      />
    </svg>
  );
};

export default MsftLogo;
